import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

export default class DeleteContactController extends Controller {
  @service declare contactsCache: ContactsCache;
  @service declare router: RouterService;
  @service declare store: Store;
  @service declare flashMessages: any;

  @tracked error?: any;
  @tracked saving = false;

  @action
  templateWillDestroy() {
    this.error = undefined;
    this.saving = false;
  }

  @action
  async hide() {
    if (this.saving) {
      return;
    }

    this.saving = true;
    try {
      let contact = this.model.contact;
      contact.active = false;
      await contact.save();
      this.router.transitionTo('funds.fund.contacts.contact');
    } catch (error) {
      this.error = error;
    }

    this.saving = false;
  }

  @action
  async delete() {
    if (this.saving) {
      return;
    }

    this.saving = true;
    try {
      let contact = this.model.contact;
      let message = `${contact.name} was deleted`;
      await contact.destroyRecord();
      this.contactsCache.removeContactId(contact.id);
      this.flashMessages.success(message);
      this.router.transitionTo('funds.fund.contacts');
    } catch (error) {
      this.error = error;
    }
    this.saving = false;
  }
}
